import React from 'react';
import { makeStyles } from "@utilities/theme_utilities";
import Grid from '@mui/material/Grid2';
import { ColorsType } from '../../../DandDPalette';
import DandDButtonBox from '@dndComponents/DandDButtonBoxSimple';

interface Props {
  name: string;
  value: boolean;
  disabled?: boolean;
  color?: string;
  colors?: ColorsType;
  image?: string;
  tooltip?: string;
  style?: React.CSSProperties | undefined;
  borderless?: boolean;
  onToggle?: () => void; 
  onMouseDown?: (event: React.MouseEvent<HTMLDivElement>) => void;
  matchButtonBox?: boolean;
}

export default function ToggleButtonBox({
  name,
  value,
  disabled = false,
  color = "",
  colors,
  image = "",
  tooltip = "",
  style = {},
  borderless = false,
  onToggle,
  onMouseDown,
  matchButtonBox = false
}: Props) {

  const useStyles = makeStyles()((theme) => {
    let useBGColor = theme.palette.primary.dark;
    let useColor = theme.palette.primary.main;
    if (colors) {
      if (colors.backgroundColor !== "") {
        useBGColor = colors.backgroundColor;
      }
      if (colors.color && colors.color !== "" && colors.color !== "Default") {
        useColor = colors.color;
      }
    } else if (color !== "") {
      useBGColor = color;
    }
    return ({
      root: {
        color: useColor,
        borderColor: useColor,
        margin: matchButtonBox ? undefined : "4px",
        // lineHeight: matchButtonBox ? 2.5 : undefined,
        // backgroundColor: theme.palette.primary.dark,
        '&:hover': {
          // color: useColor,
          backgroundColor: useBGColor,
        },
        '&.true': {
          // color: useColor,
          backgroundColor: useBGColor,
        }
      },
    });
  });
  
  const className = matchButtonBox ? `centered labs_button${disabled ? " disabled" : ""}` : `centered toggle_button ${value ? "true" : ""}${disabled ? " disabled" : ""}${borderless ? " borderless" : ""}`;
  const { classes, cx } = useStyles();

  const use_style = Object.keys(style).length > 0 ? style : {
    // width: "100%"
  };

  //Thanks to cx, className will take priority over classes.root
  // if (matchButtonBox) {
    return (
      <DandDButtonBox 
        style={use_style} 
        name={name}
        className={cx(classes.root, className)}
        disabled={disabled}
        onMouseDown={onMouseDown}
        no_labs_button
        onClick={() => {
          if (!disabled && onToggle) {
            onToggle();
          }
        }}
      />
    );
    // return (
    //   <div className="centered"
    //     style={{
    //       width: "100%"
    //     }}>
    //     <div style={use_style} 
    //       className={cx(classes.root, className)} 
    //       onMouseDown={onMouseDown}
    //       onClick={(event: React.MouseEvent<HTMLDivElement>) => {
    //         if (!disabled && onToggle) {
    //           onToggle();
    //         }
    //       }}>
    //       <Grid container spacing={0} direction="column">
    //         <Grid>
    //           { image === "" ? 
    //             <span>{ name }</span> 
    //           : 
    //             <img src={ image } alt={ name }
    //               style={{
    //                 maxWidth: "100%",
    //                 maxHeight: "100%"
    //               }} 
    //             />
    //           }
    //         </Grid>
    //       </Grid>
    //     </div>
    //   </div>
    // );
  // } else {
  //   return (
  //     <div title={tooltip}>
  //       <div
  //         className={cx(classes.root, className)} 
  //         style={style}
  //         onMouseDown={onMouseDown}
  //         onClick={() => {
  //           if (!disabled && onToggle) {
  //             onToggle();
  //           }
  //         }}>
  //         { image === "" ? 
  //           <span>{ name }</span> 
  //         : 
  //           <img src={ image } alt={ name }
  //             style={{
  //               maxWidth: "100%",
  //               maxHeight: "100%"
  //             }} 
  //           />
  //         }
  //       </div>
  //     </div>
  //   );
  // }
}
